export const analyticsActions = {
  SHOW: 'show',
  CLOSE: 'close',
};
